import React from 'react';
import ReactDOM from 'react-dom/client';
import {ConfigProvider} from "antd";
import {CookiesProvider} from "react-cookie";
import {Provider} from "react-redux";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {Main} from "./Main";
import {store} from "./store/store";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
        {
            path: "/",
            element: <Main/>,
            id: '0',
            children: [
                {
                    path: "/:lang",
                    element: <Main/>,
                    id: '1',
                }
            ]
        },
    ], {
        future: {
            v7_skipActionErrorRevalidation: true,
            v7_fetcherPersist: true,
            v7_relativeSplatPath: true,
            v7_normalizeFormMethod: true,
            v7_partialHydration: true,
        },
    })
;

root.render(
    <ConfigProvider theme={{token: {fontFamily: 'Nunito, sans-serif',}}}>
        <CookiesProvider>
            <Provider store={store}>
                {/*<React.StrictMode>*/}
                <RouterProvider router={router} future={{
                    v7_startTransition: true,
                }}/>
                {/*</React.StrictMode>*/}
            </Provider>
        </CookiesProvider>
    </ConfigProvider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

